// extracted by mini-css-extract-plugin
export default {"icon":"DepthSection_icon__ZYzwr","front":"DepthSection_front__9vLPE"};